<template>
  <a-row :gutter="20">
    <a-col :span="12">
      <patient-list v-if="empi" listUrl="/management/empiPix/patientList" :baseParams="{empi:empi}" :search="false" @onselect="handleSelect"></patient-list>
    </a-col>
    <a-col :span="12">
      <empi-pix-list ref="pix-list"></empi-pix-list>
    </a-col>
  </a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import PatientList from '@/views/project/patient/components/register/PatientList'
  import EmpiPixList from './EmpiPixList'

  export default {
    name: "EmpiPixPanel",
    mixins:[],
    components: {
      EmpiPixList,
      PatientList,
    },
    props:{
      empi:{
        type:String,
        default:''
      }
    },
    data () {
      return {
      }
    },
    computed: {
    },
    watch:{
      empi(){
        this.resetData()
      }
    },
    mounted(){
    },
    methods: {
      handleSelect(record){
        const currentRecord = {
          empi:this.empi,
          projectPatientId:record.id,
          projectId:record.projectId,
          patientName:record.name,
          patientNum:record.patientNum,
        }
        this.$refs['pix-list'].loadDataByBaseInfo(currentRecord)
      },
      resetData(){
        if(this.$refs['pix-list']){
          this.$refs['pix-list'].loadDataByBaseInfo({})
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>